import config from 'config';

import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  inputAnatomy.keys
);

const {
  colors: {
    palette: {
      theme: { input: styles }
    }
  }
} = config;

const Input = defineMultiStyleConfig({
  baseStyle: {
    field: {
      _autofill: {
        transition: 'background-color 0s 600000s, color 0s 600000s'
      }
    }
  },
  sizes: {
    md: {
      field: {
        height: '38px',
        fontSize: '15px',
        lineHeight: '20px',
        borderRadius: 20,
        pl: '10px',
        pr: 5,
        pt: '10px',
        pb: '9px'
      }
    },
    lg: {
      field: {
        height: '60px',
        fontSize: '30px',
        paddingLeft: '17px'
      },
      element: {
        height: '60px',
        width: '40px',
        right: '40px'
      },
      addon: {
        height: '60px'
      }
    },
    xl: {
      field: {
        height: '117px',
        fontSize: { base: '34px', sm: '42px', lg: '50px' },
        paddingLeft: '16px'
      },
      element: {
        height: '117px',
        width: '60px',
        right: '60px',
        svg: {
          width: '32px',
          height: '32px'
        }
      },
      addon: {
        height: '117px'
      }
    }
  },
  variants: {
    brand: {
      field: {
        fontFamily: 'main',
        color: styles.inputBrandFieldColor,
        border: '1px solid',
        borderColor: styles.inputBrandFieldBorderColor,
        bg: styles.inputBrandFieldBg,
        py: '10px',
        lineHeight: '140%',
        borderRadius: '3px',
        width: '100%',
        margin: 0,
        _hover: {
          boxShadow: 'none',
          borderColor: styles.inputBrandFieldHoverBorderColor
        },
        _placeholder: {
          color: styles.inputBrandFieldPlaceholderColor
        },
        _focusVisible: {
          boxShadow: 'none',
          borderColor: styles.inputBrandFieldFocusBorderColor
        },
        _invalid: {
          borderColor: styles.inputBrandFieldInvalidBorderColor,
          bg: styles.inputBrandFieldInvalidBg
        }
      }
    },
    auth: {
      field: {
        height: '60px',
        borderRadius: 0,
        background: styles.inputAuthFieldBg,
        padding: '0 24px',
        marginLeft: 14,
        fontSize: { base: 16, sm: 18, md: 19, xl: 22 },
        fontFamily: 'main',
        fontWeight: 'semibold',
        border: 'none',
        _placeholder: {
          fontSize: '15px',
          color: styles.inputAuthFieldPlaceholderColor,
          fontFamily: 'main',
          textTransform: 'uppercase',
          fontWeight: 400,
          letterSpacing: 0.5,
          position: 'absolute',
          top: '20px'
        },
        _invalid: {
          bg: styles.inputAuthFieldInvalidBg
        }
      }
    }
  },
  defaultProps: {
    size: 'md'
  }
});

export default Input;
